mutation ResetTugOfWarCounts($tugId: ID!, $clearDedupe: Boolean) {
  tug: StreamToolsResetTugOfWarCounts(tugId: $tugId, clearDedupe: $clearDedupe) {
    tugId
    status
    startedAt
    stoppedAt
    graceEndsAt
    version
    totalVotes
    optionA { voteCount voteCountByPlatform { twitch youtube } }
    optionB { voteCount voteCountByPlatform { twitch youtube } }
  }
}
